function groupThousands(digits: string): string {
    return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// Built arithmetically from cents, never `(cents / 100).toFixed(2)`, which can reintroduce the
// same binary float error `parseRateInput` avoids on the way in. A whole amount seeds with no
// fraction at all, matching `CurrencyInputField`'s own blur-only padding.
export function formatRateForInput(cents: number): string {
    const dollars = Math.trunc(cents / 100);
    const remainderCents = cents % 100;
    const dollarsText = groupThousands(String(dollars));

    return remainderCents === 0
        ? dollarsText
        : `${dollarsText}.${String(remainderCents).padStart(2, '0')}`;
}
